import React from 'react';
import {
    Route as ReactDOMRoute,
    RouteProps as ReactDOMRouteProps,
    Redirect
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import Private from '../layouts/Private';
import Public from '../layouts/Public';

interface RouteProps extends ReactDOMRouteProps {
    isPrivate?: boolean;
    component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({ isPrivate = false, component:Component, ...rest }) => {

    const { signed } = useAuth();   
    
    const Layout = isPrivate ? Private : Public;        

    return (
        <ReactDOMRoute 
            {...rest} 
            render={()=>{
                return  isPrivate === signed ? (                    
                    <Layout>
                        <Component/>
                    </Layout>
                ) : (
                    <Redirect to={{ pathname: isPrivate ? '/' : '/Alumisoft/home' }}/>
                )
            }} />
    );
}

export default Route;